<!--
 * @Version      : V1.0
 * @Date         : 2025-06-05 16:29:37
 * @fileName     : 合同归档
 * @Description  : 
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          
           <el-form-item label="合同名称" porp="contractName  ">
            <el-input v-model="formInline.contractName" placeholder="付款合同名称"></el-input>
          </el-form-item>
           <el-form-item label="客户负责人" porp="customerChargePerson">
            <el-input v-model="formInline.customerChargePerson" placeholder="客户负责人"></el-input>
          </el-form-item>
          <el-form-item label="我方负责人" porp="ownerChargePersonName">
            <el-input v-model="formInline.ownerChargePersonName" placeholder="我方负责人"></el-input>
          </el-form-item>
          <el-form-item label="签约类型" porp="signingType">
            <el-select clearable v-model="queryForm.signingType" filterable placeholder="签约类型">
              <el-option label="新签" value="1"></el-option>
              <el-option label="续签" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" porp="customerId">
            <el-select clearable filterable v-model="queryForm.customerId" placeholder="请选择客户">
              <el-option v-for="item in customerOption" :key="item.id" :label="item.customerName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="我方单位" porp="ownerId">
            <el-select clearable filterable v-model="queryForm.ownerId" placeholder="请选择我方单位">
              <el-option v-for="item in ownerOption" :key="item.id" :label="item.unitName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
       <el-button type="success" @click="addItem()">新增</el-button>
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
         <!-- <template #contractStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.contractStatus,'contract').type" effect="dark">{{ formatterState(row.contractStatus,'contract').text }}</el-tag>
          </div>
        </template> -->
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="edit(row)">归档</el-button>
            <!-- <el-button type="text" @click="removeItem(row)" style="color:#F56C6C;" >删除</el-button> -->
          </div>
        </template>
      </tableComponent>
    </div>
    <my-contract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT"
      :status="preStatus"></my-contract-details>
  </div>
</template>

<script>
import myContractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { auditProcessStatus, formatterState } from '@/utils/index'
import { queryContractReceivePaymentFilingApi, deleteContractReceivePaymentFilingApi } from '@/api/contractFiling/index'
import {  querySupplierInfoListApi,queryChargeListtApi,queryBasicOwnersListApi } from '@/api/basicInfo/index'
export default {
  components: {
    tableComponent,
    myContractDetails
  },
  data() {
    return {
      loading: false,
      contractCount: 0,
      totalAmount: 0,
      detailsT: '',

      formInline: {
        contractName: "",
        customerChargePerson: ""
      },
      queryForm: {
        customerId: "",
        signingType: "",
        ownerId: ""
      },
      customerOption: [],
      ownerOption: [],
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "contractName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "客户联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        
        {
          id: 4,
          title: "我方单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "合同金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "contractAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },

        // {
        //   id: 10,
        //   title: "归档类型", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "100px",
        //   keyName: "ifArchive", // 数据的属性值
        //   align: "center",
        //   slotName: "ifArchiveSlot", // 插槽名,为空字符串时不使用
        // },
        // {
        //   id: 8,
        //   title: "合同状态", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "150px",
        //   keyName: "contractStatus", // 数据的属性值
        //   align: "center",
        //   slotName: "contractStatusSlot", // 插槽名,为空字符串时不使用
        // },
        {
          id: 9,
          title: "归档日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "filingTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "操作", // 标题名称
          fixed:"right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "left",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.queryData()
    this.getChargeList()
    this.getOwnersList()
    this.getCurtomer()
  },
  methods: {
    auditProcessStatus,
    formatterState,
    //查询
    queryData() {
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            contractName: "",
            customerChargePerson: "",//合同完成状态 0 未完成 1已完成
            ...this.formInline
          },
          signingType: "",
          customerId: "",
          ownerId: "",
          ...this.queryForm
        },
        ...item
      }
      this.loading = true;
      queryContractReceivePaymentFilingApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '合同归档详情'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    addItem() {
      this.preStatus = 'add'
      this.detailsT = '合同归档新增'
      this.$refs.myComtractRefs.openDrawer({})
    },
    edit(row) {
      this.preStatus = 'edit'
      this.detailsT = '合同归档编辑'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.contractName = "";
      this.formInline.customerChargePerson = "";
      this.queryForm.signingType = "";
      this.queryForm.customerId = "";
      this.queryForm.ownerId = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    
    //我方负责人下拉
    getChargeList() {
      let params = {}
      queryChargeListtApi(params).then(res => {
        if (res.code == 200) {
          this.ownerChargePersonOption = res.data;
        }
      })
    },
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          console.log(res.data,'data')
          this.ownerOption = res.data;
        }
      })
    },
     //获取客户档案
    getCurtomer() {
      let params = {
        customerName: ""
      }
      querySupplierInfoListApi(params).then(res => {
        if (res.code == 200) {
          this.customerOption = res.data;
        }
      })
    },
    removeItem(row) {
      this.$confirm('确定要删除该合同归档？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        deleteContractReceivePaymentFilingApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .box-card-top {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px 20px;
    grid-template-rows: 100px;

    .box-card-sum {
      background-color: #54bcbd;
      height: 100%;
      border-radius: 5px;
      padding: 10px;
      box-sizing: border-box;

      .sum-title {
        color: #f7f4f4;
        font-size: 15px;
      }

      .sum-bg {
        padding-top: 20px;
        display: inline-block;
        box-sizing: border-box;
      }
    }
  }

  .box-card-bottom {
    margin-top: 20px;
    @extend .box-card-top;

    .box-card-sum {
      @extend .box-card-sum;
      background-color: #ffbf6b;
    }
  }


  .operate {
    .operate-title {
      line-height: 40px;
    }
  }
}
</style>